import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/layout/Layout";
import api from "../lib/api";
import useSeo from "../hooks/useSeo";
import { ChevronRight, ArrowUpRight } from "lucide-react";

export default function RoomTypes() {
  const [rooms, setRooms] = useState([]);
  useEffect(() => { api.get("/room-types").then((r) => setRooms(r.data || [])); }, []);
  useSeo({
    title: "Oda Planlayıcı — Otel Pro",
    description: "Oda tipine özel ekipman checklist'i. Standart, Suite, Deluxe, Engelli ve daha fazlası.",
  });

  return (
    <Layout>
      <div className="bg-softbg">
        <div className="container-site py-5 flex items-center gap-2 text-xs text-gray-500">
          <Link to="/" className="hover:text-navy">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <span className="text-navy font-medium">Oda Planlayıcı</span>
        </div>
      </div>

      <section className="bg-navy text-white py-20">
        <div className="container-site max-w-3xl">
          <p className="accent-script text-gold text-2xl mb-2">Benzersiz Araç</p>
          <h1 className="heading-serif text-3xl md:text-5xl font-semibold">Oda Tipine Göre Planlayın</h1>
          <p className="text-white/75 mt-4">
            Her oda tipinin uzmanlarımız tarafından hazırlanan checklist'i. Yıldız standartları ve konuk
            deneyimi gözetilerek kürate edildi.
          </p>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-site">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {rooms.map((r) => (
              <Link
                key={r.id}
                to={`/oda-tipleri/${r.slug}`}
                className="card-premium overflow-hidden flex flex-col group"
                data-testid={`room-card-${r.slug}`}
              >
                {r.image && (
                  <div className="aspect-[4/3] overflow-hidden bg-softbg">
                    <img src={r.image} alt={r.name_tr} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <div className="p-6 flex-1">
                  <h3 className="heading-serif text-xl font-semibold text-navy group-hover:text-gold transition-colors mb-2">
                    {r.name_tr}
                  </h3>
                  <p className="text-sm text-gray-600 line-clamp-3">{r.description}</p>
                  <span className="inline-flex items-center gap-1 text-gold text-sm mt-4">
                    Checklist'i Gör <ArrowUpRight size={14} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
